var pt = pt || {};
pt.portoeditora = pt.portoeditora || {};
pt.blocografico = pt.blocografico || {};
pt.blocografico.library = pt.blocografico.library || {};
pt.blocografico.library.counter = pt.blocografico.library.counter || {};

/**
 * Counter library — animates numeric values from a start number to an end number.
 *
 * Usage: add the class "numbers-to-grow" (or any selector) to an element and set
 * the following data attributes:
 *
 * @data {string} data-number-start
 *   The number the counter begins at. Use comma as decimal separator (e.g. "0" or "1,5").
 *
 * @data {string} data-number-end
 *   The target number the counter counts up to. Use comma as decimal separator (e.g. "100" or "3,75").
 *   The number of decimal places is inferred automatically from this value.
 *
 * @data {number} [data-step=1]
 *   How much to increment on each tick. Defaults to 1.
 *   When the remaining distance is less than the step, it switches to fine-grained
 *   decimal increments to land exactly on the target.
 *   Example: data-step="10" counts 0, 10, 20, … 100.
 *
 * @example HTML
 * <!-- Basic: counts 0 → 100 in steps of 1 -->
 * <span class="numbers-to-grow" data-number-start="0" data-number-end="100"></span>
 *
 * <!-- Fast: counts 0 → 1000 in steps of 50 -->
 * <span class="numbers-to-grow" data-number-start="0" data-number-end="1000" data-step="50"></span>
 *
 * <!-- Decimal: counts 0 → 3,75 -->
 * <span class="numbers-to-grow" data-number-start="0" data-number-end="3,75"></span>
 */
pt.blocografico.library.counter = new (function () {
  /**
   * Initialises counters for a list of elements.
   *
   * @param {NodeList|Element[]} elements        - Elements to animate.
   * @param {number} [intervalDuration=100]      - Milliseconds between each tick.
   * @param {boolean} [ifStartOnVisible=true]    - When true, the counter only starts
   *                                               when the element scrolls into view
   *                                               (uses IntersectionObserver, threshold 0.5).
   */
  function updateCounters(elements, intervalDuration = 100, ifStartOnVisible = true) {
    elements.forEach(function (element) {
      if (ifStartOnVisible) {
        const observer = new IntersectionObserver((entries, observer) => handleIntersection(entries, observer, intervalDuration), { threshold: 0.5 });
        observer.observe(element);
      } else {
        startCounter(element, intervalDuration);
      }
    });
  }

  function startCounter(element, intervalDuration) {
    const target = parseNumber(element, "numberEnd");
    let count = parseNumber(element, "numberStart");
    if (isNaN(target) || isNaN(count)) return;

    var prefix = extractPrefix(element.dataset.numberEnd);
    var decimalPlaces = countDecimalPlaces(target);
    var numberOfchars = element.dataset.numberEnd.replace(/[^0-9,]/g, "").length;
    var step = parseFloat(element.dataset.step) || 1;
    var incrementer = step;

    function increment() {
      if (target - count < step) incrementer = 1 / Math.pow(10, decimalPlaces);
      element.textContent = prefix + count.toFixed(decimalPlaces).replace(".", ",");
      count = parseFloat((count + incrementer).toPrecision(numberOfchars));
      if (count > target) {
        clearInterval(interval);
      }
    }

    var interval = setInterval(increment, intervalDuration);
  }

 

  function handleIntersection(entries, observer, intervalDuration) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.disconnect();
        startCounter(entry.target, intervalDuration);
      }
    });
  }

  function countDecimalPlaces(number) {
    var decimalPart = (number.toString().split(".")[1] || "").length;
    return decimalPart;
  }

  function extractPrefix(value) {
    const match = value.match(/^([^0-9,-]*)/);
    return match ? match[1] : "";
  }

  function parseNumber(element, dataAttribute) {
    const value = element.dataset[dataAttribute];
    if (!value) return NaN;
    const numeric = value.replace(/^[^0-9,-]+/, "").replace(",", ".");
    return parseFloat(numeric);
  }

  return {
    updateCounters,
  };
})();
